import React from "react";
import { Location } from "@navigation/Location";
import { TravelConfirmationCreatePage } from "../TravelConfirmation/TravelConfirmationCreatePage";
import { WeekYear } from "@bonliva-crm/common";

interface Params {
  bookingId: string;
  files: File[];
  week: WeekYear;
}

export class TravelConfirmationLocation extends Location<Params> {
  render() {
    return (
      <TravelConfirmationCreatePage
        bookingId={this.params.bookingId}
        files={this.params.files}
        week={this.params.week}
      />
    );
  }

  equals(location: Location<Params>) {
    return this.params.bookingId === location.params.bookingId;
  }

  toURI() {
    return `/bookings/${this.params.bookingId}/confirm-travel`;
  }
}
